<ul class="nav nav-tabs m-5">
  @if ('settings.calculation'|HasPerm) {
    <li role="presentation" [ngClass]="{active: state.is('a.calculation.list')}">
      <a uiSref="a.calculation.list">Kalkulationstabellen</a>
    </li>
  }

  @if ('settings.price.gold'|HasPerm) {
    <li role="presentation" [ngClass]="{active: state.is('a.calculation.gold')}">
      <a uiSref="a.calculation.gold">Gold</a>
    </li>
  }

  @if ('settings.price.gold'|HasPerm) {
    <li role="presentation" [ngClass]="{active: state.is('a.calculation.goldMonthly')}">
      <a uiSref="a.calculation.goldMonthly">Gold Monatspreis</a>
    </li>
  }
</ul>
